module.exports = __webpack_public_path__ + "public/img/ptz-icon5.d6ee5262.svg";